import { api } from "./api";

export const availabilityService = {
  grid: (from, until, productIds) =>
    api
      .get("/products/availability", {
        params: { from, until, product_ids: productIds?.join(",") },
      })
      .then((r) => r.data),

  consumers: (productId, date) =>
    api
      .get("/products/availability/consumers", {
        params: { product_id: productId, date },
      })
      .then((r) => r.data),
};
